import React, { useState, useEffect, useRef } from 'react';
import './LandingPage.css';
import dashboardImage from '../Images/dashboard.png';
import { motion } from 'framer-motion';
import img01 from '../Images/skil01.png';
import img02 from '../Images/skil02.png';
import img03 from '../Images/skil03.png';
import img04 from '../Images/skil04.png';
import img05 from '../Images/skil05.png';
import img06 from '../Images/skil06.png';
import img07 from '../Images/skil07.png';
import img08 from '../Images/skil08.png';
import webinarImage from '../Images/webinar.jpg';
import Containerlan from './Containerlan';
import { FaPlay } from "react-icons/fa";

import user1 from '../Images/user1.png';
import user2 from '../Images/user2.png';
import user3 from '../Images/user3.png';
import { useLocation } from "react-router-dom";




import AOS from 'aos';
import 'aos/dist/aos.css';
import Slideslan from './Slideslan';
import JobSourcing from './JobSemless';
import FAQ from './FAQ';

import Reviews from '../Images/Reviews_Section.png'
import { Link } from 'react-router-dom';
import ClientFeedbackSection from './ClientFeedbackSection';
import TCSLogo from '../Images/tcs-logo.png';
import InfosysLogo from '../Images/infosys-logo.png';
import GoogleLogo from '../Images/google-logo.png';
import AccentureLogo from '../Images/accenture-logo.png';
import CognizantLogo from '../Images/cognizant-logo.png';
import WiproLogo from '../Images/wipro-logo.png';
import imm from '../Images/imm.png';
import pari from '../Images/pari.png';
import mani from '../Images/mani.png';
import geltec from '../Images/geltec.png';

import Ankita from '../Images/Ankita.jpg';
import Sneha from '../Images/Sneha.jpg';
import Shabbir from '../Images/Shabbir.jpg';
import Varun from '../Images/Varun.jpg';
import Rahul from '../Images/Rahul.jpg';
import Rohit from '../Images/Rohit.jpg';

export default function LandingPage() {

  const reviews = [
    {
      name: "Rahul Mehta",
      text: "Before SkillsHap, we struggled with scattered placement efforts and poor student preparation. Within just one month of onboarding, we saw structured mock interviews, resume improvements, and real employer interest. It’s a complete placement system in one platform",
      image: user1,
    },
    {
      name: "Neha Kapoor",
      text: "We wanted a way to plug career services into our learning model without building from scratch. SkillsHap integrated seamlessly. Our learners now graduate with jobs in hand — and we’ve seen a direct impact on retention and reviews.",
      image: user3,
    },
    {
      name: "Abhinav Sharma",
      text: "We’ve been running technical courses for years, but the placement side always lagged. SkillsHap helped us add industry readiness — mock interviews, career mentorship, and recruiter connects. Our placement rates have doubled.",
      image: user2,
    },
    {
      name: "Sanya Reddy",
      text: "TAs a hiring partner, we get flooded with unprepared profiles. With SkillsHap, we get job-ready candidates who’ve already cleared mock rounds. It saves us time and gives our clients better results..",
      image: user3,
    },
    {
      name: "Sandeep Chauhan",
      text: "SkillsHap has filled the critical gap between academics and employability. They bring structure, mentorship, and real industry feedback — things our curriculum couldn’t do alone. It’s become a value-add to our placement team.",
      image: user3,
    },
    {
      name: "Anjali Deshmukh",
      text: "We hired 3 candidates through the SkillsHap platform — every one of them was prepared, professional, and confident. You can tell they’ve gone through real prep and coaching. We’ll definitely come back for more.",
      image: user3,
    },
  ];

  const leftToRight = [...reviews.filter((_, i) => i % 2 === 0), ...reviews.filter((_, i) => i % 2 === 0)];
  const rightToLeft = [...reviews.filter((_, i) => i % 2 !== 0), ...reviews.filter((_, i) => i % 2 !== 0)];


  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location])

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scrollTo");

    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 200);
      }
    }
  }, [location]);


  // Left Cards
  const leftCard1 = {
    title: 'Unified Job Portal + Tracker',
    description: 'Easily track your job applications and manage all opportunities in one place.'
  };

  const leftCard2 = {
    title: 'AI + Human Mentorship Model',
    description: 'Leverage AI tools combined with expert mentors for complete guidance.'
  };

  const leftCard3 = {
    title: 'AI-Optimized Resume Builder',
    description: 'Create powerful, ATS-friendly resumes with AI-driven recommendations.'
  };

  // Right Cards
  const rightCard1 = {
    title: 'Mock Interviews with Experts',
    description: 'Simulate real interview experiences with personalized feedback.'
  };

  const rightCard2 = {
    title: 'Skill Assessment + Simulation Projects',
    description: 'Test your knowledge with real-world project simulations and track progress.'
  };

  const rightCard3 = {
    title: 'All-in-One Career System',
    description: 'A unified platform covering everything from resume to offer letter.'
  };

  // Group them into arrays for rendering
  const leftCards = [leftCard1, leftCard2, leftCard3];
  const rightCards = [rightCard1, rightCard2, rightCard3];

  const successCards = [
    {
      text: `The mentorship from Abdul sir helped me reinvent my career path. Shweta ma’am’s mock sessions gave me real confidence before interviews.`,
      name: 'Abdul Rehman Muttah',
      role: 'QA Engineer, Immidart Technologies LLP',
      company: 'PlaySimple Games',
      stars: 5,
      avatar: Shabbir,
      hike: '120%',
      companyLogo: imm
    },
    {
      text: `What stood out was how deeply Shweta and Abdul understood my challenges. Their support made me believe I could thrive in this industry.`,
      name: 'Roopak Gupta',
      role: 'Software Developer, PhysicsWallah',
      company: 'PhysicsWallah',
      stars: 4,
      avatar: Varun,
      hike: '100%',
      companyLogo: TCSLogo
    },
    {
      text: `From career confusion to clarity — thanks to Abdul Sabir and Shweta Gupta. Their mentorship wasn’t just helpful, it was life-changing.`,
      name: 'Mohammad Azam',
      role: 'Software Developer, CC33 Global Limited',
      company: 'CC33 Global Limited',
      stars: 5,
      avatar: InfosysLogo,
      hike: '80%',
      companyLogo: Rohit
    },
    {
      text: `Shweta ma’am’s structured mentorship and Abdul sir’s constant motivation made my transition feel possible. Their guidance was personal and spot-on.`,
      name: 'Pranali Jouras',
      role: 'Product Manager, Ambit Finvest',
      company: 'Ambit Private Limited',
      stars: 5,
      avatar: Ankita,
      hike: '95%',
      companyLogo: WiproLogo
    },
    {
      text: `Abdul sir’s career mapping + Shweta ma’am’s prep sessions = perfect formula. Their combined support helped me crack multiple top companies.`,
      name: 'Yash Joshi',
      role: 'Software Engineer, Big Binary LLC',
      company: 'BigBinary',
      stars: 4,
      avatar: Rahul,
      hike: '90%',
      companyLogo: CognizantLogo
    },
    {
      text: `I owe my confidence and clarity to Abdul Sabir and Shweta Gupta. Their mentorship felt like having industry veterans rooting for your success.`,
      name: 'Aishwarya Muralidhar',
      role: 'Product Manager, Tracxn',
      company: 'Tracxn Bengaluru',
      stars: 5,
      avatar: Sneha,
      hike: '110%',
      companyLogo: AccentureLogo
    },
    {
      text: `The mentorship journey with Abdul and Shweta felt like having career guardians. They never let me give up and helped me shape my next move.`,
      name: 'Mansi Mahawar',
      role: 'Business Analyst, Geltec Innovative Healthcare',
      company: 'Innovative Healthcare',
      stars: 5,
      avatar: mani,
      hike: '90%',
      companyLogo: geltec
    },
  ];

  const statsData = [
    { value: 250, suffix: '+', label: '🤝 Hiring Partners' },
    { value: 70, suffix: '%', label: '📈 Success Rates' },
    { value: 100000, suffix: '+', label: '🎓 Candidates' },
    { value: 30, suffix: '+', label: '👨‍🏫 Career Mentors' },
  ];

  const countersRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const counter = entry.target;
            const target = parseInt(counter.getAttribute('data-target'), 10);
            const suffix = counter.getAttribute('data-suffix');
            let current = 0;
            const increment = Math.ceil(target / 50);

            const update = () => {
              current += increment;
              if (current < target) {
                counter.innerText = `${current}${suffix}`;
                requestAnimationFrame(update);
              } else {
                counter.innerText = `${target}${suffix}`;
              }
            };

            update();
            observer.unobserve(counter);
          }
        });
      },
      { threshold: 0.5 }
    );

    countersRef.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const brands = [img01, img02, img03, img04, img05, img06, img07, img08];

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;

    const scroll = () => {
      if (scrollContainer && !isHovered) {
        const nextScrollLeft = scrollContainer.scrollLeft + 1;

        if (
          nextScrollLeft >=
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollContainer.scrollTo({ left: nextScrollLeft, behavior: 'smooth' });
        }
      }
    };

    intervalRef.current = setInterval(scroll, 30); // Adjust speed as needed

    return () => clearInterval(intervalRef.current);
  }, [isHovered]);


  return (

    <div className="landing-wrapper">
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <div className="container">
        {/* Hero Section */}
        <div className="hero-section">
          <p className="trusted">TRUSTED BY OVER 10K+ JOB SEEKERS</p>
          <div className="user-reviews">
            <img src={Reviews} alt="user1" className="user-img" />
            {/* <span className="stars">★★★★★</span> */}
            {/* <span className="reviews">from 200+ reviews</span> */}
          </div>
          <h2 className="hero-title">
            Achieve Your Dream Job <span className="highlight">5X Faster</span> with <span className="highlight">SkillsHap</span>
          </h2>
          <p className="hero-description">
            Empowering your career journey through AI-driven tools and personalized guidance
          </p>
          <div className="cta-buttons">
            <button className="cta-btn arrow-expand" onClick={() => scrollToSection('skill-assignment')}>
              <span>AI Resume Builder →</span>
            </button>

            <button className="cta-btn arrow-expand" onClick={() => scrollToSection('skill-assignment')}>
              <span>AI Skills Assessment →</span>
            </button>

            <button className="cta-btn arrow-expand" onClick={() => scrollToSection('skill-assignment')}>
              <span>Student Portal →</span>
            </button>

            <button className="cta-btn arrow-expand" onClick={() => scrollToSection('skill-assignment')}>
              <span>Mock Interviews →</span>
            </button>
          </div>


          <div className="cta-actions" data-aos="zoom-in">
            <Link to="/BookDemoForm">
              <div className="glow-animated-border">
                <button className="btn btn-primary modern-demo-button">
                  <FaPlay className="play-icon" />
                  &nbsp; BOOK A DEMO
                </button>
                <span className="glow-line line1"></span>
                <span className="glow-line line2"></span>
                <span className="glow-line line3"></span>
              </div>
            </Link>

            <Link to="/SignupForm">
              <button className="cta-primary signup-btn"> SIGN UP FOR FREE TRAIL</button>
            </Link>
          </div>
        </div>

        {/* Dashboard Preview */}
        <div className="dashboard-section">
          <div className="dashboard-image-container fade-in">
            <img src={dashboardImage} alt="Dashboard Preview" className="dashboard-img" />
          </div>
        </div>

        {/* Career Section */}
        <div className="career-section">
          <h2 className="career-heading">
            Your <span className="highlight">All-in-One</span> Career Growth Platform
          </h2>
          <p className="career-subheading">
            Master in-demand skills with expert-led sessions, AI-powered tools, and real-world experience.
          </p>

          <div className="career-content">

            {/* Left Cards */}
            <div className="career-cards">
              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0 }}
                viewport={{ once: true }}
              >
                <h4>Too many job sites, can’t keep track.</h4>
                <p>
                  Manage every job from one clean dashboard.
                  Stay focused with zero missed follow-ups.</p>
              </motion.div>

              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <h4>No mentors, no career direction.</h4>
                <p>Get expert guidance + smart AI tracking.
                  Stay aligned, motivated, and moving forward.</p>
              </motion.div>

              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h4>Resume keeps getting ignored.</h4>
                <p>Build a resume that beats ATS filters.
                  Designed to stand out and get seen.</p>
              </motion.div>
              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h4>Fear of interviews or no prep?</h4>
                <p>Practice with real hiring managers.
                  Walk in confident with expert feedback.</p>
              </motion.div>
            </div>

            {/* Image Box */}
            <motion.div
              className="career-image-box"
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="overlay-content">
                <h4></h4>
                {/* <p>Begin Your Journey - It's Time to Get Noticed</p> */}
                {/* <Link to="/SignupForm">  <button>SIGN UP FOR FREE</button></Link> */}


              </div>
            </motion.div>

            {/* Right Cards */}
            <div className="career-cards">
              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0 }}
                viewport={{ once: true }}
              >
                <h4>No experience, no job stuck in a loop.</h4>
                <p>Showcase your skills through real simulations.
                  Let your work speak louder than your resume.
                </p>
              </motion.div>

              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <h4>Don’t know where to begin.
                </h4>
                <p>
                  Get one platform for resume, prep, and search.
                  Stop jumping tools start with structure.</p>
              </motion.div>

              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h4>Getting rejected but don’t know why.
                </h4>
                <p>Get feedback at every stage — resume to HR.
                  Understand, fix, and move forward with clarity.</p>
              </motion.div>
              <motion.div
                className="career-card"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h4>No referrals, no response.</h4>
                <p>Tap into our recruiter and mentor network.
                  Bridge the gap between you and real jobs.</p>
              </motion.div>
            </div>

          </div>
        </div>
        {/* /Stats Counter/ */}
        <div className="stats-wrapper">
          <div className='stat-signup'>
            <h2 className="signup-heading">
              Start Your Journey with <span className="highlight-skillshap">SkillsHap</span>
            </h2>
            <p className='stat-subheading'>Stop applying blindly. Start landing offers with expert tools, guidance, and connections.</p>
            <Link to="/SignupForm">  <button className='stat-btn'>SIGN UP FOR FREE</button></Link>
          </div>
          <h2 className="stats-title">
            Unlock Your Potential with{" "}
            <span className="highlight-text">AI-Powered Career Tools.</span>
          </h2>

          <div className="stats">
            {statsData.map((item, index) => (
              <div className="stat-card" key={index}>
                <h3>
                  <span
                    ref={(el) => (countersRef.current[index] = el)}
                    data-target={item.value}
                    data-suffix={item.suffix}
                  >
                    0{item.suffix}
                  </span>
                </h3>
                <p>{item.label}</p>
              </div>

            ))}
            <Link to="/BookDemoForm">
              <div className="cta-button-wrapper">
                <button className="cta-button">LET'S BEGIN - BOOK A CALL</button>
              </div></Link>
          </div>

        </div>

        <div id="skill-assignment">
          <Containerlan />
        </div>

        <ClientFeedbackSection />


        {/* Placement Brands */}
        <div className="brand-row-wrapper">
          <h2 className="heading" style={{ textAlign: 'center' }}>
            Secure Placements with <span className="highlight">Top Brands</span>
          </h2>

          <p className="subheading" style={{ textAlign: 'center' }}>
            Connect with Leading Employers & Land Career-Defining Opportunities.
          </p>


          <div className="brand-scroller">
            <div className="brand-track">
              {[...brands, ...brands].map((logo, index) => (
                <div className="brand-logo" key={index}>
                  <img src={logo} alt={`brand-${index}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Success Section */}
        <div className="success-auto-section">
          <h2 className="success-auto-title">
            Champion <span className="success-auto-highlight">Success Stories</span>
          </h2>
          <p className="success-auto-subtitle">Inspiring Career Transformations</p>

          <div
            className={`success-auto-container ${isHovered ? "paused" : ""}`}
            ref={scrollRef}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >

            <div className="success-auto-track">
              {[...successCards, ...successCards].map((card, index) => (
                <div className="success-auto-card" key={index}>
                  <div className="success-auto-img-wrapper">
                    <img src={card.avatar} alt="avatar" className="success-auto-avatar" />
                  </div>
                  <div className="success-auto-center-content">
                    <h3 className="success-auto-name">{card.name}</h3>
                    <p className="success-auto-role">{card.role}</p>
                    <div className="success-auto-stars">{'⭐'.repeat(card.stars)}</div>
                  </div>
                  <div className="success-auto-bottom">
                    <div className="success-auto-logo">
                      <img src={card.companyLogo} alt={`${card.company} logo`} />
                    </div>
                    <div className="success-auto-hike">Hike: {card.hike}</div>
                  </div>
                  <p className="success-auto-text">{card.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
<JobSourcing />

        <Slideslan />
        
        {/* webinarsection  */}
        <div className="webinar-section">
          <div className="webinar-left">
            <h2>
              Transform your future with <br />
              <span className="highlight">SkillsHap webinars</span>
            </h2>
            <p>
              Explore both free and paid webinars covering trending topics
              all in one place. Gain valuable insights, enhance your skills, and stay ahead in your career.
            </p>
            <Link to="/RegisterNow">
              <button className="signup-btn09">REGISTER WEBINAR</button></Link>
          </div>
          <div className="webinar-right">
            <div className="image-wrapper">
              <img src={webinarImage} alt="SkillsHap Webinar Promo" />
            </div>
          </div>
        </div>
        <FAQ />
      </div>
    </div>
  );
}
